import { createCtx } from '@nic/commons'
import { requestExpirationDayReducer, requestExpirationDaysByIdInitialState } from '@nic/nic-api'

const [ctx, Provider] = createCtx(
  requestExpirationDayReducer,
  requestExpirationDaysByIdInitialState
)
export const RequestExpirationDaysContext = ctx
export const RequestExpirationDaysProvider = Provider
